<template>
  <a-modal
    ref="comModal"
    title="小区"
    v-model="comModalVisible"
    @ok="ok"
    :width="750"
  >
    <a-alert
      v-if="community.searchError"
      :message="community.errorMessage"
      type="warning"
      showIcon
    ></a-alert>
    <a-form-model
      :mode="community.queryParam"
      :labelCol="{ span: 7 }"
      :wrapperCol="{ span: 17 }"
    >
      <a-row :gutter="48">
        <a-col :md="12" :sm="24">
          <a-form-model-item label="省份">
            <a-select
              v-model="community.queryParam.provinces"
              placeholder="请选择省份"
              allow-clear
              @change="handleProvinceChange"
            >
              <a-select-option
                v-for="item in provinceList"
                :value="item.code"
                :key="item.code"
                >{{ item.descript }}({{ item.code }})</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="城市">
            <a-select
              v-model="community.queryParam.city"
              placeholder="请选择城市"
              allowClear
            >
              <a-select-option
                v-for="item in tmpCityList"
                :value="item.code"
                :key="item.code"
                >{{ item.descript }}({{ item.code }})</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="小区名称"
            ><a-input
              v-model="community.queryParam.communityName"
              placeholder="小区名称"
          /></a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="">
            <div style="display: flex;align-items: center;justify-content: space-between;">
<!--              <a-switch checked-children="是" un-checked-children="否" v-model="community.queryParam.isSearchMerchantHot" />-->
              <div></div>
              <div>
                <a-button
                    type="primary"
                    style="margin-right: 10px;"
                    @click="searchCommunity"
                >查询</a-button
                >
                <a-button @click="resetCommunity">重置</a-button>
              </div>
            </div>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="查询常用小区">
            <a-switch checked-children="是" un-checked-children="否" @change="switchChange"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <s-table
      ref="table"
      size="small"
      rowKey="communityCode"
      :columns="columns"
      :data="loadData"
      :isAuto="false"
      showPagination="auto"
      :rowSelection="options.rowSelection"
    >
      <span slot="action" slot-scope="text, record">
        <template>
          <a class="a-action" v-if="community.queryParam.isSearchMerchantHot !=true " @click="hotCommunity(record,'add')">添加常用小区</a>
          <a class="a-action" v-else @click="hotCommunity(record,'remove')">删除常用小区</a>
        </template>
      </span>
    </s-table>
  </a-modal>
</template>

<script>
import { STable } from "@/components";
export default {
  name: "CommunityModal",
  components: {
    STable
  },
  data() {
    return {
      comModalVisible: false,
      community: {
        searchError: false,
        errorMessage: "",
        queryParam: {
          isSearchMerchantHot: false,
          provinces: undefined,
          city: undefined, //城市
          communityName: "" //小区名称
        }
      },
      // 表头
      columns: [
        {
          title: "小区名称",
          dataIndex: "communityName"
        },
        {
          title: "地理位置",
          dataIndex: "position"
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "left",
          width: 120,
          fixed: "right",
          scopedSlots: { customRender: "action" }
        }
      ],
      selectedRowKeys: [],
      options: {
        rowSelection: {
          type: "radio",
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        let param = Object.assign(parameter, this.community.queryParam);
        param.isSearchMerchantHot = param.isSearchMerchantHot == true ? "T" : "F";
        return this.$http.roomBksApi.pageHouseCommunity(param).then(res => {
          return res.resultObject;
        });
      },
      selectItem: {
        communityCode: "",
        communityName: ""
      },
      provinceList: [],
      cityList: [],
      tmpCityList: []
    };
  },
  created() {},
  methods: {
    show() {
      this.comModalVisible = true;
      this.getBaseHelpCode();
    },
    async getBaseHelpCode() {
      this.$http.systemBksApi
        .findProvinceCityDistrictCircleHelpCode({
          isProvince: "T",
          isCity: "T"
        })
        .then(res => {
          this.provinceList = res.resultObject.provinceList;
          this.cityList = res.resultObject.cityList;

          let userInfo = this.$store.getters.userInfo;
          let merchant = userInfo.merchant;
          if (merchant) {
            let merchantInfo = merchant.merchantInfo;
            if (merchantInfo) {
              this.community.queryParam.provinces = merchantInfo.province;
              this.community.queryParam.city = merchantInfo.city;
              this.handleProvinceChange(merchantInfo.province);
            }
          }
        });
    },
    handleProvinceChange(value) {
      let arr = [];
      for (let city of this.cityList) {
        if (city.provinceCode == value) {
          arr.push(city);
        }
      }
      this.tmpCityList = arr;
    },
    searchCommunity() {
      if (
        !this.community.queryParam.provinces &&
        !this.community.queryParam.city
      ) {
        this.community.errorMessage = "请选择省份或城市";
        this.community.searchError = true;
      } else {
        this.community.searchError = false;
        if(this.community.queryParam.isSearchMerchantHot == true || this.community.queryParam.isSearchMerchantHot =='T'){
          let userInfo = this.$store.getters.userInfo;
          let merchant = userInfo.merchant;
          if (merchant && merchant.merchantInfo) {
            this.community.queryParam.merchantNo = merchant.merchantInfo.merchantNo;
          }
        } else {
          this.community.queryParam.merchantNo = "";
        }
        this.$refs.table.refresh(true);
      }
    },
    switchChange(checked){
      this.community.queryParam.isSearchMerchantHot = checked;
      if(checked){
        let userInfo = this.$store.getters.userInfo;
        let merchant = userInfo.merchant;
        if (merchant && merchant.merchantInfo) {
          this.community.queryParam.merchantNo = merchant.merchantInfo.merchantNo;
        }
      } else {
        this.community.queryParam.merchantNo = "";
      }
      this.$refs.table.refresh(true);
    },
    resetCommunity() {
      this.community.queryParam = {};
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectItem.communityCode = selectedRowKeys[0];
      this.selectItem.communityName = selectedRows[0].communityName;
    },
    hotCommunity(item, type){
      let userInfo = this.$store.getters.userInfo;
      let merchant = userInfo.merchant;
      if (merchant && merchant.merchantInfo) {
        let param = {
          communityCode: item.communityCode,
          merchantNo: merchant.merchantInfo.merchantNo,
          operationType: type
        };
        this.$http.roomBksApi.saveMerchantHotCommunity(param).then(res => {
          if (res.result == 0) {
            this.$message.success(res.msg);
          }
        });
      }
    },
    ok() {
      this.comModalVisible = false;
      this.$emit("sure", this.selectItem);
    }
  }
};
</script>

<style></style>
